export default {
  url: process.env.REACT_APP_API_URL ?? "",
  apiKey: process.env.REACT_APP_API_KEY ?? "",
  auth: {
    audience: process.env.REACT_APP_AUTH_AUDIENCE ?? "",
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID ?? "",
  },
} as const;
